import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'A public limited company, a company governed by the Insurance Code, with share capital of 12,558,240 euros. 8/14, avenue des Frères Lumière 94368 Bry-sur-Marne Cedex\n\nCréteil Trade and Companies Register and subject to supervision by the ACPR (French Prudential Supervisory Authority)',
    noticeCta: 'Insurance notice',
    summaryCta: 'Summary information document',
    title: 'Insured by Mutuaide Assistance',
  },
  fr: {
    description:
      'Société Anonyme, Entreprise régie par le Code des Assurances, au capital de 12.558.240 euros. 8/14, avenue des Frères Lumière 94368 Bry-sur-Marne Cedex\n\nRCS Créteil 383 974 086 et soumise au contrôle de l’ACPR (Autorité de Contrôle Prudentiel et de Résolution)',
    noticeCta: 'Notice de l’assurance',
    summaryCta: 'Document d’information synthétique',
    title: 'Assuré par Mutuaide Assistance',
  },
} as const);

export default locales;
